import type { IconName } from '@helsenorge/designsystem-react/components/Icons/IconNames';

import Panel, { type PanelProps } from '@helsenorge/core-cms/panel';

export interface LinkBlockProps extends PanelProps {
  icon: IconName;
}

const LinkBlock: React.FunctionComponent<LinkBlockProps> = ({ icon, ...rest }) => <Panel icon={icon} {...rest} />;

export default LinkBlock;
